export const SIGN_UP_NEW_PROFILE_EMAIL_PARAM = 'newProfileEmail'
export const SIGN_UP_NEW_PROFILE_TYPE_PARAM = 'newProfile'
export const SIGN_UP_NEW_PUBLISHER_PROFILE_EMAIL_PARAM = 'email'
export const SIGN_UP_NEW_PROFILE_EPID_PARAM = 'epid'
